module.exports = __webpack_public_path__ + "static/img/logo_white_business.faa48b25.png";